/* eslint jsx-a11y/mouse-events-have-key-events: 0 */
import React, { useState } from "react";
import MapStyle from "./MapStyle.json";
import { Link } from "gatsby";
import Pin from "../../assets/pin.png";

import {
  Container,
  P,
  Button,
  InfoContainer,
  LoadingContainer,
} from "./Components";
import {
  Map,
  Marker,
  InfoWindow,
  GoogleApiWrapper,
} from "google-maps-react";
import CircularProgress from '@material-ui/core/CircularProgress';

const mapLoadingContainer = () => {
  return (
    <LoadingContainer>
      <P bold spaceBottom title>A carregar a Rota de Produtores</P>
      <CircularProgress />
    </LoadingContainer>
  );
}

const MapContainer = ({ google, producers }) => {

  const [selectedMarker, setSelectedMarker] = useState(null);
  const [producerInfo, setProducerInfo] = useState(null);
  const [showInfo, setShowInfo] = useState(false);

  const _mapLoaded = (mapProps, map) => {
    map.setOptions({
      styles: MapStyle
    })
  }

  const markerSelectHandler = (props, marker, producerInfo) => {
    if (!selectedMarker) {
      setMarker(marker, producerInfo);
    } else {
      if (marker.position.lat() !== selectedMarker.position.lat() ||
        marker.position.lng() !== selectedMarker.position.lng()) {
        setMarker(marker, producerInfo);
      }
    }
  }

  const setMarker = (marker, producerInfo) => {
    setSelectedMarker(marker);
    setProducerInfo(producerInfo);
    setShowInfo(true);
  }

  const cleanMarker = () => {
    setShowInfo(false);
    setSelectedMarker(null);
    setProducerInfo(null);
  }

  return (
    <Container>
      {producers ? (
        <Map
          containerStyle={{
            height: '65vh',
          }}
          mapTypeControl={false}
          streetViewControl={false}
          google={google}
          zoom={10}
          initialCenter={{
            lat: 40.573730,
            lng: -7.884814,
          }}
          onReady={(mapProps, map) => {
            _mapLoaded(mapProps, map);
          }}
        >
          {producers.map((producer) => {
            return (
              <Marker
                key={producer.id}
                name={producer.name}
                onClick={(props, marker) => markerSelectHandler(props, marker, producer)}
                position={{
                  lat: producer.location.latitude,
                  lng: producer.location.longitude
                }}
                icon={{
                  url: Pin,
                }}
              />
            );
          })}
          <InfoWindow
            marker={selectedMarker}
            onClose={cleanMarker}
            visible={showInfo}
            maxWidth="200px"
          >
            {producerInfo &&
              <InfoContainer>
                <img
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '5px',
                  }}
                  src={producerInfo.logo.publicURL}
                  alt="producer-logo"
                />
                <P bold title>Contactos:</P>
                <div style={{ marginBottom: '10px' }}>
                  <P>{producerInfo.telephone && producerInfo.telephone}</P>
                  <P>{producerInfo.email && producerInfo.email}</P>
                  <P>{producerInfo.address && producerInfo.address}</P>
                </div>
                {producerInfo.description && <P bold title>Descrição:</P>}
                {producerInfo.description && <P spaceBottom>{producerInfo.description}</P>}
                {!producerInfo.mapOnly &&
                  <Link to={`/producer/${producerInfo.slug}`}>
                    <Button>Visitar o Produtor »</Button>
                  </Link>
                }
              </InfoContainer>
            }
          </InfoWindow>
        </Map>
      ) : (
          <LoadingContainer>
            <P bold title>A carregar a Rota de Produtores</P>
            <CircularProgress classes={{ colorPrimary: "C9B79F" }} />
          </LoadingContainer>
        )}
    </Container>
  );
};

export default GoogleApiWrapper({
  apiKey: "AIzaSyBra_XriMSVd41OQcbU57yiSldq8M4buyo",
  LoadingContainer: mapLoadingContainer,
})(MapContainer)
